import React from 'react'
import PropTypes from 'prop-types'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import EnhancedTable from 'components/tables/enhanced-table'
import { DateTime } from 'luxon'

const columns = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    width: '50%',
    mobile: true,
    sortable: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    width: '50%',
    mobile: true,
    sortable: false,
  },
]

const formatSentDate = sentAt => DateTime.fromISO(sentAt).toFormat('LLL d')

const PendingInvitesList = ({ invites }) => {
  const rows = invites.map(invite => (
    <TableRow
      key={invite.id}
      data-testid={`pending-invite-row-${invite.contact.id}`}
    >
      <TableCell>
        <Typography variant="body2" noWrap>
          {`${invite.contact.firstName} ${invite.contact.lastName}`}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="textSecondary" noWrap>
          {invite.sentAt
            ? `Invite sent ${formatSentDate(invite.sentAt)}`
            : 'Invite queued'}
        </Typography>
      </TableCell>
    </TableRow>
  ))

  return (
    <EnhancedTable
      rows={rows}
      columns={columns}
      label="Pending invites"
      variant="list"
      showHeaderPagination={false}
      showPaginator={false}
      emptyState={() => null}
    />
  )
}

PendingInvitesList.propTypes = {
  invites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      sentAt: PropTypes.string,
      contact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }).isRequired,
    }),
  ).isRequired,
}

export default PendingInvitesList
